module.exports = __webpack_public_path__ + "static/media/c182.8a110dc4.png";